<template>
  <acclaro-datatable
    grid-title="My Review Tasks"
    search-route="/datatables/my-tasks"
    search-placeholder="Filter Review Tasks..."
    datatable-name="myreviewtask"
    :grid-classes="[options.isReviewerOnly ? 'reviewer-only' : '']"
    :is-reviewer-only="options.isReviewerOnly"
    :no-results="'No review tasks found'"
    :options="{
      sortable: [
        'Task', 'Order', 'Review Status', 'Assigned', 'Target',
        'Assigned By', 'Due', 'Completed'
      ],
      perPage: 20
    }"
    :column-templates="templates"
  >
    <template v-slot:buttons v-if="!options.isReviewerOnly">
    </template>
  </acclaro-datatable>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

import {
  PencilIcon,
  FileMoveIcon,
  EmailIcon
} from '../icons.js';

import {
  AsLink,
  AsStatus,
  AsInfo,
  AsCell
} from '../Acclaro-Datatable/cells';

export default {

  props: {

    options: {
      type: Object,
    }
  },

  computed: {

    templates () {
      let $vm = this;

      return {
        Task: function (h, row, index) {
          const props = { row, column: 'Task' };
          return (
            <AsLink
              props={props}
              link={'/my-review-tasks/' + row.id}
              link-text={row.Task}
            />
          );
        },

        Instructions: function (h, row, index) {
          const props = { row, column: 'Instructions' };
          return (
            <AsInfo props={props} title={'Instructions'} />
          );
        },

        'Review Status': function (h, row, index) {
          const props = { row, column: 'Review Status' };
          return (
            <AsStatus
              props={props}
              fill-color={$vm.reviewStatusColor(row['Review Status'])} />
          );
        },

        Assigned: function (h, row, index) {
          const props = { row, column: 'Assigned' };
          return (
            <AsCell props={props} content={$vm.formatDate(props.row.Assigned)} />
          );
        },

        Due: function (h, row, index) {
          return (
            <div>
              <span style={$vm.pastDue(row['Due']) && !row.Completed ? 'color:#CC0000' : ''}>
                {$vm.formatDate(row['Due'])}
              </span>
            </div>
          );
        },

        Completed: function (h, row, index) {
          const props = { row, column: 'Completed' };

          return (
            <AsCell props={props} content={row.Completed ? $vm.formatDate(row.Completed) : '-'} />
          );
        },
      }
    }
  },

  methods: {

    reviewStatusColor (status) {
      const reviewStatusColors = {
        'assigned': '#1F8CEE',
        'open': '#1F8CEE',
        'complete': '#68C71E',
        'canceled': '#000000'
      };

      return reviewStatusColors[status];
    },

    formatDate (date) {
      if (!moment(date).isValid()) return '-';

      return moment(date).format('DD-MMM-YYYY')
    },

    pastDue (date) {
      if (!moment(date).isValid()) return false;

      return moment(date).isBefore(moment(), 'day');
    },
  },

  data () {
    return {}
  },
}
</script>
